export default {
    SEND_TO_GRAPH: "Отправить на граф"
};
